@if (claimNumberSig()) {
	<nav @expandCollapse>
		<ul class="breadcrumb-bar">
			<li class="breadcrumb">
				<button class="ao-link" (click)="goBack()" aria-label="Go back to track a claim page">
					Track a Claim
				</button>
				<i class="fa fa-caret-right ao-left-8"></i>
			</li>
			<li class="breadcrumb ao-left-8">
				<p>Claim #{{ claimNumberSig() }}</p>
			</li>
		</ul>
	</nav>
}
